"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounced = exports.useMounted = exports.delay = void 0;
const react_1 = require("react");
function delay(timeout) {
    return new Promise(r => setTimeout(r, timeout));
}
exports.delay = delay;
function useMounted() {
    const mountedRef = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);
    return mountedRef;
}
exports.useMounted = useMounted;
function useDefaultResult(fn, value) {
    const [error, setError] = (0, react_1.useState)();
    const [result, setResult] = (0, react_1.useState)();
    const mounted = useMounted();
    (0, react_1.useEffect)(() => {
        (async function () {
            try {
                const res = await fn(value);
                if (mounted.current)
                    setResult(res);
            }
            catch (err) {
                if (mounted.current)
                    setError(err);
            }
        })();
    }, [fn, mounted, value]);
    return [result, error];
}
function useDebounced(fn, timeout, defaultValue) {
    const [defaultResult] = useDefaultResult(fn, defaultValue);
    const [error, setError] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [result, setResult] = (0, react_1.useState)();
    const mounted = useMounted();
    const threadRef = (0, react_1.useRef)();
    const executor = (0, react_1.useCallback)(async (value) => {
        if (value === defaultValue) {
            setResult(defaultResult);
            return;
        }
        setLoading(true);
        const s = Symbol("executor");
        threadRef.current = s;
        await delay(timeout);
        if (threadRef.current !== s)
            return;
        let res;
        try {
            res = await fn(value);
        }
        catch (err) {
            if (mounted.current)
                setError(err);
        }
        if (mounted.current)
            setLoading(false);
        if (threadRef.current !== s)
            return;
        if (mounted.current)
            setResult(res);
    }, [defaultResult, defaultValue, fn, mounted, timeout]);
    return [result, loading, error, executor];
}
exports.useDebounced = useDebounced;
exports.default = useDebounced;
//# sourceMappingURL=data:application/json;base64,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